import { SVGProps } from 'react';

const KaajaLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={125}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.46 17.091 13.873 30.47c.563.562 1.536.562 2.15 0l13.411-13.378c.614-.561.614-1.532 0-2.144L16.022 1.569c-.563-.613-1.536-.613-2.15 0L.46 14.947c-.615.562-.615 1.532 0 2.144Zm7.811 6.335 14.252.028V8.44H8.271a.596.596 0 0 0-.584.597v13.793c0 .325.265.597.584.597Z"
        fill="#2824E5"
      />
      <path
        d="m21.719 23.097-6.516-6.372a.985.985 0 0 1 0-1.43l6.552-6.536c.41-.408 1.074-.436 1.483-.027l6.167 6.167c.615.612.715 1.52 0 2.234l-6.077 6.053c-.41.409-1.162.358-1.61-.09Z"
        fill="#03005E"
      />
      <path
        d="M55.303 24.854h-4.178a.463.463 0 0 1-.408-.204L44.654 17.2v7.196c0 .306-.204.51-.51.51h-3.72c-.305 0-.509-.204-.509-.51V1.94c0-.306.204-.51.51-.51h3.72c.305 0 .509.204.509.51v13.627l6.063-7.043a.578.578 0 0 1 .408-.153h3.974c.458 0 .662.51.408.867l-6.013 6.941 6.216 7.86a.503.503 0 0 1-.407.816ZM70.945 8.37h3.16c.305 0 .509.204.509.51v15.515c0 .307-.204.51-.51.51h-3.668c-.306 0-.51-.203-.51-.51v-1.633c-.56.766-1.375 1.327-2.445 1.787-1.07.459-2.242.612-3.516.612-2.446 0-4.382-.766-5.91-2.348-1.478-1.582-2.242-3.623-2.242-6.175 0-2.603.815-4.644 2.394-6.226 1.58-1.582 3.669-2.348 6.267-2.348 1.223 0 2.344.204 3.312.612 1.02.409 1.835.97 2.446 1.736l.255-1.582c0-.307.204-.46.458-.46Zm-9.12 11.636c.866.868 1.987 1.276 3.363 1.276 1.375 0 2.547-.408 3.413-1.225.867-.816 1.325-1.939 1.325-3.317v-.306c0-1.327-.407-2.399-1.274-3.215-.866-.817-1.987-1.225-3.362-1.225-1.376 0-2.497.408-3.363 1.276-.867.867-1.274 1.99-1.274 3.419-.102 1.327.357 2.45 1.172 3.317ZM91.887 8.37h3.16c.305 0 .509.204.509.51v15.515c0 .307-.204.51-.51.51h-3.668c-.306 0-.51-.203-.51-.51v-1.633c-.56.766-1.375 1.327-2.445 1.787-1.07.459-2.242.612-3.516.612-2.446 0-4.382-.766-5.91-2.348-1.478-1.582-2.243-3.623-2.243-6.175 0-2.603.816-4.644 2.395-6.226 1.58-1.582 3.669-2.348 6.267-2.348 1.223 0 2.344.204 3.312.612 1.02.409 1.834.97 2.446 1.736l.255-1.582c0-.307.203-.46.458-.46Zm-9.12 11.636c.866.868 1.987 1.276 3.363 1.276 1.375 0 2.547-.408 3.413-1.225.866-.816 1.325-1.939 1.325-3.317v-.306c0-1.327-.407-2.399-1.274-3.215-.866-.817-1.987-1.225-3.362-1.225-1.376 0-2.497.408-3.363 1.276-.867.867-1.274 1.99-1.274 3.419-.102 1.327.356 2.45 1.172 3.317ZM99.239 8.458a.51.51 0 0 0-.51.51V25.21c0 2.123-.393 2.822-2.358 2.915a.53.53 0 0 0-.51.52v2.851c0 .271.212.496.483.501 5.178.09 6.745-2.89 6.745-6.787V8.968a.51.51 0 0 0-.509-.51h-3.341ZM120.395 8.37h3.159c.305 0 .509.204.509.51v15.515c0 .307-.204.51-.509.51h-3.669c-.306 0-.509-.203-.509-.51v-1.633c-.561.766-1.376 1.327-2.446 1.787-1.07.459-2.242.612-3.516.612-2.445 0-4.382-.766-5.91-2.348-1.478-1.582-2.242-3.623-2.242-6.175 0-2.603.815-4.644 2.395-6.226 1.579-1.582 3.668-2.348 6.267-2.348 1.222 0 2.343.204 3.312.612 1.018.409 1.834.97 2.445 1.736l.255-1.582c0-.307.204-.46.459-.46Zm-9.121 11.636c.866.868 1.987 1.276 3.363 1.276s2.548-.408 3.414-1.225c.866-.816 1.325-1.939 1.325-3.317v-.306c0-1.327-.408-2.399-1.274-3.215-.866-.817-1.987-1.225-3.363-1.225s-2.497.408-3.363 1.276c-.866.867-1.274 1.99-1.274 3.419-.051 1.327.357 2.45 1.172 3.317Z"
        fill="#2824E5"
      />
      <path
        d="M100.599 5.971 98.051 3.42a.494.494 0 0 1 0-.714L100.6.153a.492.492 0 0 1 .713 0l2.548 2.552a.494.494 0 0 1 0 .714l-2.548 2.552a.492.492 0 0 1-.713 0Z"
        fill="#03005E"
      />
    </g>
  </svg>
);

const KaajaMiniLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={48}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M48 0H0v48h48V0Z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.733 25.2 22.8 39.234c.591.589 1.611.589 2.255 0L39.123 25.2c.644-.59.644-1.607 0-2.25L25.055 8.92c-.59-.643-1.61-.643-2.255 0L8.733 22.95c-.644.59-.644 1.607 0 2.25Zm8.193 6.645 14.949.03v-15.75h-14.95a.625.625 0 0 0-.613.626V31.22c0 .341.28.626.614.626Z"
      fill="#2824E5"
    />
    <path
      d="m31.031 31.5-6.835-6.684a1.034 1.034 0 0 1 0-1.5l6.873-6.855c.43-.428 1.126-.457 1.556-.029l6.469 6.469c.644.643.75 1.594 0 2.344l-6.375 6.349c-.43.428-1.22.375-1.688-.094Z"
      fill="#03005E"
    />
  </svg>
);

export { KaajaLogo, KaajaMiniLogo };
